'use strict';

module.exports = {
  template: require('./salary-overview.html'),
  controller: require('./salary-overview.controller'),
  controllerAs: 'vm',

  bindings: {
    invites : '<'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/salary/salary-overview/index.js
 ** module id = 242
 ** module chunks = 0
 **/